/*! Copyright TransformCO or its affiliates. All Rights Reserved.*/
import styled from 'styled-components';

export const FormSection = styled.div`
  position: fixed;
  bottom: 10px;
  right: 30px;
  @media ${props => props.device.laptop}{
    width: 320px;
    bottom: 10px;
    right: 80px;
    height: 500px;
  }
  width: 320px;
  height: 500px;
  overflow-y: auto;
  
  background: linear-gradient(rgb(255, 255, 255), rgb(255, 255, 255) 80%, rgb(255, 255, 255));
  z-index:999;

  display: flex;
  flex-direction: column;
  border-radius : 10px;
  box-shadow: rgb(0 0 0 / 19%) 0px 10px 20px, rgb(0 0 0 / 23%) 0px 6px 6px;
`;

export const FormHeader = styled.div`
        background: ${props => props.primarycolor ? props.primarycolor : "#3F5773"};
        @media ${props => props.device.laptop}{
            padding: 5px;
        }
        padding: 5px;
        border-radius: 0px;
        height: 40px;
        

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;

        
`;

export const FormLogo = styled.img`
    margin-right: 8px;
    max-height: 36px;
    max-width: 36px;
`
export const ChatIconBtn = styled.button`
    background: none;
    border: none;

    :hover {
        color:  #fff;
        background:  #efecec4d;
        border-radius : 5px;
    }
`

export const Form = styled.form`
	@media ${props => props.device.laptop}{
		// height: 460px;
  	}
    // height: 360px;
	display: flex;
    flex-direction: column;
    row-gap: 0.7rem;
	align-items: center;
	transition: right .6s ease-in-out;
`;

export const SubmitButton = styled.button`
    cursor: pointer;
    transition: color 0.3s ease 0s,background-color 0.3s ease 0s;

    width: 100%;
    background: #003980;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    font-size: 15px;
    letter-spacing: 1px;
    opacity:0.8;

    :hover{
        opacity : 1
    }
`;

export const FormBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    box-shadow: 0px -20px 20px -10px rgb(140 140 140 / 14%);
    padding: 20px;
    border-radius: 10PX;
    margin-bottom: 10%;
}
`
export const ChatRatingHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .header-l1 {
        margin: 7px;
        font-size: 20px;
        text-align: center;
    }
    .header-l2 {
        font-size: 16px;
        text-align: center;
    }
`

export const ChatStarRatingComp = styled.div`
    display: flex;
    flex-direction: row;
    gap: 3px;

    font-size: 2rem;
    justify-content: center;
`


export const StarRatingBtn = styled.div`
    .on {
        color: #FF9529
    }
    .off {
        color: #0e0e0e7a;
    }
`

export const ChatReasonComp = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    .active {
        background: ${props => props.primarycolor};
    }
`
export const ChatReasonButton = styled.button`
    cursor: pointer;
    transition: color 0.3s ease 0s,background-color 0.3s ease 0s;

    width: 80%;
    background: #0e0e0e7a;
    color: white;
    border: none;
    padding: 4px;
    border-radius: 3px;
    font-size: 13px;
    font-stretch: extra-expanded;
    letter-spacing: 1px;
    margin: 0px;
`

export const ChatReasonButtonNote = styled.div`
    font-size: 12px;
    width: 80%;
    text-align: center;
    color: #003980;
    letter-spacing: 0.5px;
`

export const ChatCommentComp = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap : 3px;
`

export const ChatCommentTextArea = styled.textarea`
    width: 80%;
    min-height: 50px;    
    max-height: 100px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    font-size: 16px;
    resize: vertical;

`

export const ChatSubmitComp = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    gap: 10px;
    margin-top: 10px;

    .s-feedback {
        text-decoration: underline;
        font-size: 18px;
        cursor: pointer;
    }
`

export const ChatFeedbackSubmitButton = styled.button`
    cursor: pointer;
    transition: color 0.3s ease 0s,background-color 0.3s ease 0s;

    width: 50%;
    background: ${props => props.primarycolor};
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    font-size: 13px;
    letter-spacing: 1px;
    opacity:0.8;

    :hover{
        opacity : 1
    }
`

export const ChatFeedbackSkipButton = styled.span`
    text-decoration : underline;
    cursor: pointer;
`

export const FeedbackSuccessComp = styled.span`
    text-align: center;
    color: #003980;
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap : 5px;
`